export default __webpack_public_path__ + "static/media/coversUmbrella.f61a57e9.svg";